import http from '../../../../common/utils/http'
import apiUtils from '../../../../common/utils/apiUtils'
import {API_BASE_URL} from '../../../../common/utils/commonUrl'

export default {
  searchCustomerByCondition: (data) => {
    return http.get(`${API_BASE_URL}/api/wxoa/member/member/getPendingMemberList`, {params: data}).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  auditingCustomerById: (data) => {
    return http.post(`${API_BASE_URL}/api/wxoa/member/member/applyMember`, data).then(
      function (result) {
        return apiUtils.getDataFormCodeResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/go-out-management/certification-audit/certification-audit.js